import { composePlugins } from './compose-plugins';
import { withInlines } from './with-inlines';
import { withMarkers } from './with-markers';
import { withReadOnly } from './with-read-only';
import { withUnselectable } from './with-unselectable';
import { withVoids } from './with-voids';

/**
 * Plugins that are used in all versions of the editor. withApply is omitted since its position in
 * the overall plugin list is important.
 */
export const withCorePlugins = composePlugins(
  withReadOnly,
  withInlines,
  withVoids,
  withUnselectable,
  withMarkers
);
